import React, { useState } from "react";
import styles from "./Loan.module.css";
import SaveBtn from "../../Buttons/SaveBtn";
import { Grid, InputLabel } from "@mui/material";
import NewFormTextInput from "../../FormTextInput/NewFormTextInput";
import CountryCodePhoneInput from "../../CountryCodePhoneInput/CountryCodePhoneInput";
import CancelBtn from "../../Buttons/CancelBtn";
import edufinEdit from "../../../assets/images/edufinEdit.svg";
import AutoCompleteField from "../../AutoCompleteField/AutoCompleteField";
import right from "../../../assets/images/edufinIcon.svg";

const MyApplication = () => {
  const [index, setIndex] = useState(0);

  const renderInstituteDetail = () => {
    return (
      <div className={styles.loanContent}>
        <div className={styles.loanHeader}>Institute Details</div>
        <div className={styles.subHeader}>Register your account</div>
        <Grid xs={6} marginTop="5px" paddingBottom="5px">
          <AutoCompleteField
            id="branchId"
            label="Select your Institute (Type 3 letters or more to search)"
            options={[]}
            optionLabel={"branchName"}
            required={true}
          />
        </Grid>
        <Grid xs={6} marginTop="20px">
          <div className={styles.buttonContainer}>
            <CancelBtn buttonText={"Cancel"} />
            <SaveBtn buttonText={"Continue"} onClick={() => setIndex(1)} />
          </div>
        </Grid>
      </div>
    );
  };

  const renderFee = () => {
    return (
      <div className={styles.loanContent}>
        <div className={styles.loanHeader}>KYC</div>
        <Grid xs={10} marginTop="5px" paddingBottom="5px">
          <AutoCompleteField
            id="branchId"
            label="Select your Institute (Type 3 letters or more to search)"
            options={[]}
            optionLabel={"branchName"}
            required={true}
            disabled={true}
          />
        </Grid>
        <div className={styles.feeContainer}>
          <Grid xs={3} marginTop="5px" paddingBottom="5px">
            <div className={styles.feeHeader}>Education fee</div>
          </Grid>
          <div className={styles.feeSubContainer}>
            <div className={styles.feeRow}>
              <Grid xs={5} marginTop="5px" paddingBottom="5px">
                <NewFormTextInput
                  validate={true}
                  label="Student Name"
                  type="text"
                  id={"instituteName"}
                  placeholder="eg: React learning Hub"
                  inputProps={{
                    maxLength: 100,
                  }}
                  require={true}
                />
              </Grid>
              <Grid xs={5} marginTop="5px" paddingBottom="5px">
                <NewFormTextInput
                  validate={true}
                  label="Student DOB"
                  type="text"
                  id={"instituteName"}
                  placeholder="eg: React learning Hub"
                  inputProps={{
                    maxLength: 100,
                  }}
                  require={true}
                />
              </Grid>
            </div>
            <div className={styles.feeRow}>
              <Grid xs={5} marginTop="5px" paddingBottom="5px">
                <AutoCompleteField
                  id="branchId"
                  label="Course"
                  options={[]}
                  optionLabel={"branchName"}
                  required={true}
                  disabled={true}
                />
              </Grid>
              <Grid xs={5} marginTop="5px" paddingBottom="5px">
                <AutoCompleteField
                  id="branchId"
                  label="Academic Year"
                  options={[]}
                  optionLabel={"branchName"}
                  required={true}
                  disabled={true}
                />
              </Grid>
            </div>
            <div className={styles.feeRow}>
              <Grid xs={5} marginTop="5px" paddingBottom="5px">
                <NewFormTextInput
                  validate={true}
                  label="Annual Fee"
                  type="text"
                  id={"instituteName"}
                  placeholder="eg: React learning Hub"
                  inputProps={{
                    maxLength: 100,
                  }}
                  require={true}
                />
              </Grid>
              <Grid xs={5} marginTop="5px" paddingBottom="5px">
                <AutoCompleteField
                  id="branchId"
                  label="Institute Branch"
                  options={[]}
                  optionLabel={"branchName"}
                  required={true}
                  disabled={true}
                />
              </Grid>
            </div>
          </div>
        </div>
        <div className={styles.feeContainer}>
          <Grid xs={5} margin="10px 10px">
            <div className={styles.loanHeader}>Available Plans</div>
          </Grid>
          <div className={styles.feeSubContainer}>
            <div className={styles.planContainer}>
              <div className={styles.planInfo}>
                <div className={styles.planMoneyInfo}>
                  <div>3 Month Plan</div>
                  <div className={styles.amount}>₹ 2,199/Month</div>
                  <div className={styles.amountSub}>
                    per user/month, Billed Monthly
                  </div>
                </div>
                <div className={styles.planMoneyInfo}>
                  <div className={styles.planMoneyDesc}>
                    <div>
                      <img src={right} />
                    </div>
                    <div className={styles.planMoneyDescText}>
                      Flexible payment dates
                    </div>
                  </div>
                  <div className={styles.planMoneyDesc}>
                    <div>
                      {" "}
                      <img src={right} />
                    </div>
                    <div className={styles.planMoneyDescText}>
                      Flexible payment dates
                    </div>
                  </div>
                  <div className={styles.planMoneyDesc}>
                    <div>
                      <img src={right} />
                    </div>
                    <div className={styles.planMoneyDescText}>
                      Flexible payment dates
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.planButtonContainer}>
                <CancelBtn buttonText={"Select"} />
              </div>
            </div>
            <div className={styles.planContainer}>
              <div className={styles.planInfo}>
                <div className={styles.planMoneyInfo}>
                  <div>6 Month Plan</div>
                  <div className={styles.amount}>₹ 2,199/Month</div>
                  <div className={styles.amountSub}>
                    per user/month, Billed Monthly
                  </div>
                </div>
                <div className={styles.planMoneyInfo}>
                  <div className={styles.planMoneyDesc}>
                    <div>
                      <img src={right} />
                    </div>
                    <div className={styles.planMoneyDescText}>
                      Affordable EMI spread across 9 months
                    </div>
                  </div>
                  <div className={styles.planMoneyDesc}>
                    <div>
                      <img src={right} />
                    </div>
                    <div className={styles.planMoneyDescText}>
                      Flexible payment dates
                    </div>
                  </div>
                  <div className={styles.planMoneyDesc}>
                    <div>
                      <img src={right} />
                    </div>
                    <div className={styles.planMoneyDescText}>
                      Flexible repayment options
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.planButtonContainer}>
                <SaveBtn buttonText={"Selected"} />
              </div>
            </div>
            <div className={styles.planContainer}>
              <div className={styles.planInfo}>
                <div className={styles.planMoneyInfo}>
                  <div>12 Month Plan</div>
                  <div className={styles.amount}>₹ 2,199/Month</div>
                  <div className={styles.amountSub}>
                    per user/month, Billed Monthly
                  </div>
                </div>
                <div className={styles.planMoneyInfo}>
                  <div className={styles.planMoneyDesc}>
                    <div>
                      <img src={right} />
                    </div>
                    <div className={styles.planMoneyDescText}>
                      Lowest monthly EMI (12 months)
                    </div>
                  </div>
                  <div className={styles.planMoneyDesc}>
                    <div>
                      <img src={right} />
                    </div>
                    <div className={styles.planMoneyDescText}>
                      Flexible payment dates
                    </div>
                  </div>
                  <div className={styles.planMoneyDesc}>
                    <div>
                      <img src={right} />
                    </div>
                    <div className={styles.planMoneyDescText}>
                      Extended repayment flexibility
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.planButtonContainer}>
                <CancelBtn buttonText={"Select"} />
              </div>
            </div>
          </div>
        </div>
        <Grid xs={12} marginTop="20px">
          <div className={styles.buttonContainer}>
            <CancelBtn buttonText={"Cancel"} />
            <SaveBtn buttonText={"Submit"} onClick={() => setIndex(2)} />
          </div>
        </Grid>
      </div>
    );
  };

  const renderIntegratedPage = () => {
    return (
      <div className={styles.loanContent}>
        <div className={styles.integratedContainer}>
          <div className={styles.renderIntegratedHeadLine}>
            <div>Education Fee Loan</div>
            <div>
              <img src={edufinEdit} height={"20px"} width={"20px"} />
            </div>
          </div>
          <div style={{ margin: "5px 0px" }}>Lender:Fibe</div>
          <div
            className={styles.renderIntegratedHeaderLine}
            style={{
              margin: "20px 0px",
            }}
          >
            <div>
              Name:
              <span style={{ color: "rgba(35, 166, 123, 1) " }}>Raghu</span>
            </div>
            <div>
              Application No:
              <span style={{ color: "rgba(35, 166, 123, 1) " }}>
                8892929292
              </span>
            </div>
            <div>
              Status
              <span style={{ color: "rgba(35, 166, 123, 1) " }}>
                djcn@jkd.cpm
              </span>
            </div>
          </div>
          <div className={styles.renderIntegratedSecondLine}>
            <div>
              Applied Amount:
              <span style={{ color: "rgba(35, 166, 123, 1) " }}>50000</span>
            </div>
            <div>
              Tenure:
              <span style={{ color: "rgba(35, 166, 123, 1) " }}>9 Month</span>
            </div>
            <div>
              Loan Status:
              <span style={{ color: "rgba(35, 166, 123, 1) " }}>Applied</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.loanContainer}>
      <div>
        {index === 0
          ? renderInstituteDetail()
          : index === 1
          ? renderFee()
          : index === 2
          ? renderIntegratedPage()
          : ""}
      </div>
    </div>
  );
};

export default MyApplication;
